import PropTypes from 'prop-types';
import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

/**
 *  Deleting confirmation popup container.
 *
 * @param props {Object}.
 * @param {Function} props.delete Function to call deleting api.
 * @param {boolean} props.isPopupFetching Show spinner icon and disable ok button if true.
 * @param {string} props.message Popup message.
 * @param {string} props.title Popup title.
 */
const DeleteConfirmPopupContainer = ({
  isPopupFetching,
  delete: deleteFn,
  message = 'Are you sure you want to delete the selected database record(s)? The records and all associate data will be permanently deleted.',
  title = 'Delete selected',
}) => {
  const { closePopup } = usePopupContext();

  const handleOk = useCallback(() => {
    if (!isPopupFetching) {
      deleteFn();
    }
  }, [isPopupFetching, deleteFn]);

  const handleCancel = useCallback(() => {
    closePopup();
  }, [closePopup]);

  const header = (
    <span>
      <i aria-hidden="true" className="fa fa-exclamation-triangle text-danger" /> {title}
    </span>
  );

  return (
    <Popups.ConfirmPopup
      header={header}
      message={message}
      onCancel={handleCancel}
      onOk={handleOk}
      waiting={isPopupFetching}
    />
  );
};

DeleteConfirmPopupContainer.propTypes = {
  delete: PropTypes.func.isRequired,
  isPopupFetching: PropTypes.bool.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
};

function mapStateToProps(state, props) {
  const { popup } = props;

  return {
    isPopupFetching: popup.get('isPopupFetching'),
    delete: popup.getIn(['props', 'delete']),
    message: popup.getIn(['props', 'message']),
    title: popup.getIn(['props', 'title']),
  };
}

export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(DeleteConfirmPopupContainer));
